import { gql } from '@apollo/client';

export const discordLinkByTokenQuery = gql`
  query DiscordLinkByToken($token: String!) {
    discordLinkByToken(token: $token) {
      discordUsername
      isExpired
    }
  }
`;

export const confirmDiscordLinkMutation = gql`
  mutation ConfirmDiscordLink($token: String!) {
    confirmDiscordLink(token: $token) {
      id
      discordUserId
      discordUsername
      linkedAt
    }
  }
`;

export const unlinkDiscordMutation = gql`
  mutation UnlinkDiscord {
    unlinkDiscord
  }
`;

export const cityHasDiscordConnectionsQuery = gql`
  query CityHasDiscordConnections($slug: String!) {
    city(slug: $slug) {
      id
      hasDiscordConnections
      discordConnections {
        id
        guildName
      }
    }
  }
`;

export const myDiscordLinkQuery = gql`
  query MyDiscordLink {
    me {
      id
      discordLink {
        id
        discordUserId
        discordUsername
        isLinked
        dmEventReminders
        dmEventUpdates
        dmEventComments
        linkedAt
      }
    }
  }
`;

export const updateDiscordNotificationPreferencesMutation = gql`
  mutation UpdateDiscordNotificationPreferences($dmEventReminders: Boolean, $dmEventUpdates: Boolean, $dmEventComments: DiscordDMEventCommentsPreference) {
    updateDiscordNotificationPreferences(dmEventReminders: $dmEventReminders, dmEventUpdates: $dmEventUpdates, dmEventComments: $dmEventComments) {
      id
      dmEventReminders
      dmEventUpdates
      dmEventComments
    }
  }
`;
